import { ChevronRight } from '@mui/icons-material';
import { Box, Card, CardActionArea, CardContent, Typography } from '@mui/material';
import { format } from 'date-fns';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import TypeChip from '../chip/TypeChip';
import { SimulationSummary } from '../types';
import { useDesktop } from '../useDesktop';
import { formatDuration, formatTime } from '../utils/formatTime';

export type SimulationSummaryCardProps = SimulationSummary & { showDetails?: boolean; to: string; key?: string };

const formatTimeDate = (date: Date) => `${formatTime(date, { timeStyle: 'medium' })}, ${format(date, 'd MMMM yyy')}`;

const SimulationSummaryCard = ({
  endTime,
  name,
  position,
  showDetails,
  startTime,
  status,
  to,
}: SimulationSummaryCardProps) => {
  const isDesktop = useDesktop();

  return (
    <Card>
      <CardActionArea component={RouterLink} to={to}>
        <CardContent>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
            <Typography component="h2" variant={isDesktop ? 'h5' : 'h6'} flex={1}>
              {name}
            </Typography>

            <TypeChip type={status} />
            <ChevronRight sx={{ color: 'text.secondary' }} />
          </Box>

          {showDetails && (
            <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Typography variant={isDesktop ? 'subtitle1' : 'body1'} color="text.secondary">
                <Box component="span" fontWeight={{ sm: 'bold' }}>
                  From:
                </Box>{' '}
                {formatTimeDate(startTime)}
              </Typography>

              <Typography variant={isDesktop ? 'subtitle1' : 'body1'} color="text.secondary">
                <Box component="span" fontWeight={{ sm: 'bold' }}>
                  To:
                </Box>{' '}
                {endTime ? formatTimeDate(endTime) : '-'}
              </Typography>

              <Typography variant={isDesktop ? 'subtitle1' : 'body1'} color="text.secondary">
                <Box component="span" fontWeight={{ sm: 'bold' }}>
                  Duration:
                </Box>{' '}
                {endTime ? formatDuration(startTime, endTime) : '-'}
              </Typography>

              {position && (
                <Typography variant={isDesktop ? 'subtitle1' : 'body1'} color="text.secondary">
                  <Box component="span" fontWeight={{ sm: 'bold' }}>
                    Position:
                  </Box>{' '}
                  {position}
                </Typography>
              )}
            </Box>
          )}
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default SimulationSummaryCard;
